import SlotList from "./SlotList";
import { getDoctorImageSrc } from "../../utility/getDoctorImageSrc";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MdChevronRight, MdCurrencyRupee } from "react-icons/md";
import { BsCalendar2WeekFill } from "react-icons/bs";
import { RiStethoscopeLine } from "react-icons/ri";
import { FaUserMd, FaChevronRight } from "react-icons/fa";
import { RiAwardLine } from "react-icons/ri";

const formatDate = (date) => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

const DoctorList = ({
  slots,
  selectedDoctor,
  selectedSpecialty,
  addNotification,
  fromDate,
  toDate,
  slotsByDate,
  doctorList = [],
}) => {
  const doctorInfo = {
    name: slots[0].DOCTORNM,
    specialization: slots[0].SPEILISATION,
    DOCTORFEES: slots[0].DOCTORFEES,
    REGFESS: slots[0].REGFESS,
    DOCLINK: slots[0].DOCLINK || "",
  };

  const getDayName = (dateString) => {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${month}/${day}/${year}`);
    return days[date.getDay()];
  };

  const formatDisplayDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    const date = new Date(`${month}/${day}/${year}`);

    return date.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      // year: "numeric",
    });
  };

  return (
    <>
      {/* <AppointmentSelect /> */}
      <div className="max-w-7xl mx-auto px-0 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* LEFT SIDE — DOCTOR CARD */}
          <div className="lg:col-span-1">
            <div
              className="doctor-card-scroll bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden sticky top-28 w-full"
              style={{ maxHeight: "calc(100vh - 120px)", overflowY: "auto" }}
            >
              {/* Top blue accent */}
              <div
                className="h-1.5 w-full"
                style={{
                  background: "linear-gradient(90deg, #0095da, #00b4d8)",
                }}
              />

              <div className="p-4 lg:p-6">
                {/* Avatar */}
                <div className="flex flex-col items-center text-center">
                  <div className="relative">
                    <div className="w-24 h-24 lg:w-32 lg:h-32 rounded-full overflow-hidden ring-4 ring-[#0095da]/15 shadow-lg">
                      <img
                        src={getDoctorImageSrc(selectedDoctor?.image)}
                        alt={selectedDoctor?.label}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          e.currentTarget.src = "/doctor-dummy.png";
                        }}
                      />
                    </div>
                    <div className="absolute bottom-1 right-1 w-3.5 h-3.5 lg:w-4 lg:h-4 bg-green-400 rounded-full border-2 border-white shadow-sm" />
                  </div>

                  {/* Name */}
                  <h3 className="mt-3 text-lg lg:text-xl font-black text-slate-800 tracking-tight leading-tight">
                    Dr. {doctorInfo?.name}
                  </h3>

                  {/* Specialization pill */}
                  <div className="mt-1.5 flex items-center justify-center gap-1.5 bg-blue-50 border border-blue-100 rounded-full px-3 py-1">
                    <FaUserMd style={{ color: "#0095da", fontSize: "10px" }} />
                    <span
                      style={{
                        color: "#0095da",
                        fontSize: "11px",
                        fontWeight: 600,
                      }}
                    >
                      {doctorInfo?.specialization}
                    </span>
                  </div>

                  <div
                    className="w-10 h-0.5 rounded-full mt-3 mb-3"
                    style={{ backgroundColor: "#0095da40" }}
                  />
                </div>

                {/* About */}
                {selectedDoctor?.about && (
                  <div className="mb-4">
                    <div className="flex items-center gap-2 mb-2">
                      <RiAwardLine
                        style={{
                          color: "#0095da",
                          fontSize: "13px",
                          flexShrink: 0,
                        }}
                      />
                      <span
                        className="text-[10px] font-bold uppercase tracking-[2px]"
                        style={{ color: "#0095da" }}
                      >
                        About Doctor
                      </span>
                    </div>
                    <p
                      className="text-slate-500 leading-relaxed line-clamp-3"
                      style={{ fontSize: "11px" }}
                    >
                      {selectedDoctor?.about}
                    </p>
                    <a href={doctorInfo?.DOCLINK} target="_blank">
                      <button className="mt-2 flex items-center gap-1.5 group transition-all duration-200">
                        <span
                          style={{
                            color: "#0095da",
                            fontSize: "11px",
                            fontWeight: 600,
                          }}
                        >
                          View Full Profile
                        </span>
                        <FaChevronRight
                          style={{ color: "#0095da", fontSize: "8px" }}
                          className="group-hover:translate-x-0.5 transition-transform duration-200"
                        />
                      </button>
                    </a>
                  </div>
                )}

                <div
                  className="h-px mb-3"
                  style={{ backgroundColor: "#0095da10" }}
                />

                {/* Consultation Fee */}
                <div
                  className="rounded-xl overflow-hidden w-full"
                  style={{
                    border: "1px solid #0095da25",
                    boxShadow: "0 4px 20px rgba(0,149,218,0.08)",
                    background:
                      "linear-gradient(145deg, #f0f9ff 0%, #ddf1fb 100%)",
                  }}
                >
                  <div className="px-3 py-3 flex items-center justify-between gap-2">
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1.5 mb-1.5">
                        <div
                          className="w-1 h-3 rounded-full shrink-0"
                          style={{ backgroundColor: "#0095da" }}
                        />
                        <span
                          style={{
                            fontSize: "9px",
                            color: "#0095da",
                            fontWeight: 700,
                            letterSpacing: "1.5px",
                            textTransform: "uppercase",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Consultation Fee
                        </span>
                      </div>
                      <div
                        className="flex items-center"
                        style={{ marginLeft: "-2px" }}
                      >
                        <MdCurrencyRupee
                          style={{
                            fontSize: "16px",
                            color: "#0a2540",
                            flexShrink: 0,
                          }}
                        />
                        <span
                          className="truncate"
                          style={{
                            fontSize: "clamp(18px, 2.5vw, 26px)",
                            fontWeight: 900,
                            color: "#0a2540",
                            letterSpacing: "-1px",
                            lineHeight: 1,
                          }}
                        >
                          {doctorInfo?.DOCTORFEES}
                        </span>
                      </div>
                    </div>

                    <div
                      className="shrink-0 rounded-xl flex items-center justify-center"
                      style={{
                        width: "36px",
                        height: "36px",
                        background:
                          "linear-gradient(135deg, #0095da15, #0095da30)",
                        border: "1px solid #0095da30",
                      }}
                    >
                      <RiStethoscopeLine
                        style={{ fontSize: "16px", color: "#0095da" }}
                      />
                    </div>
                  </div>

                  <div
                    className="px-3 py-1.5 flex items-center gap-1.5"
                    style={{
                      borderTop: "1px solid #0095da15",
                      background: "rgba(0,149,218,0.04)",
                    }}
                  >
                    <div
                      className="w-1.5 h-1.5 rounded-full animate-pulse shrink-0"
                      style={{ backgroundColor: "#22c55e" }}
                    />
                    <span
                      className="truncate"
                      style={{
                        fontSize: "9px",
                        color: "#64748b",
                        fontWeight: 500,
                      }}
                    >
                      Available for online booking
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE — AVAILABLE SLOTS */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-6 pb-4 border-b border-gray-100">
                {/* Left: Title */}
                <div className="flex items-center gap-3">
                  <div className="bg-slate-100 p-2.5 rounded-xl">
                    <FaRegCalendarAlt className="w-5 h-5 text-slate-600" />
                  </div>
                  <div>
                    <p className="text-[10px] text-slate-400 font-semibold uppercase tracking-widest">
                      Showing slots for
                    </p>
                    <h3 className="text-slate-800 font-bold text-base leading-tight">
                      Available Time Slots
                    </h3>
                  </div>
                </div>

                {/* Right: Date Range */}
                <div className="flex items-center gap-2 border border-slate-200 bg-slate-50 rounded-xl px-3.5 py-2 self-start sm:self-auto">
                  <FaRegCalendarAlt className="text-slate-400 text-sm shrink-0" />
                  <span className="text-slate-700 font-semibold text-sm">
                    {formatDate(fromDate)}
                  </span>
                  <MdChevronRight className="text-slate-300 text-lg" />
                  <span className="text-slate-700 font-semibold text-sm">
                    {formatDate(toDate)}
                  </span>
                </div>
              </div>
              {/* <div className="bg-white shadow-sm rounded-xl p-5 border border-gray-100 mb-6">
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
                  <div className="flex items-center gap-3">
                    <span className="text-[#ffff] bg-[#ec3737] p-2 rounded-full">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </span>
                    <h3 className="text-lg font-semibold text-gray-900">
                      Available Time Slots
                    </h3>
                  </div>

                  <div className="bg-[#248886] text-[#ffff] px-4 py-2 rounded-lg font-medium">
                    {formatDate(fromDate)} → {formatDate(toDate)}
                  </div>
                </div>
              </div> */}

              {/* DATE-WISE SLOTS */}
              {Object.entries(slotsByDate).map(([date, dateSlots]) => (
                <div key={date} className="mb-10">
                  <div className="inline-flex items-center gap-3 mb-5 bg-blue-50 border border-blue-100 rounded-2xl px-4 py-3">
                    {/* Icon box */}
                    <div className="bg-[#0095da] flex items-center justify-center w-10 h-10 rounded-xl shrink-0 shadow-sm shadow-blue-200">
                      <BsCalendar2WeekFill className="text-white text-base" />
                    </div>

                    {/* Date info */}
                    <div className="flex flex-col">
                      <span className="text-[10px] text-[#0095da] font-bold uppercase tracking-[2px] leading-none mb-1">
                        {getDayName(date)}
                      </span>
                      <span className="text-base font-bold text-slate-800 leading-none">
                        {formatDisplayDate(date)}
                      </span>
                    </div>
                  </div>
                  {/* <div
                    className="flex items-center gap-4 mb-4 bg-[#0095da]"
                    style={{
                      padding: "15px",
                      width: "max-content",
                      borderRadius: "12px",
                    }}
                  >
                    <div className="bg-white p-3 rounded-xl">
                      <svg
                        className="w-7 h-7 text-[red]"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                      </svg>
                    </div>

                    <div>
                      <p className="text-lg font-bold text-white">
                        {formatDisplayDate(date)}
                      </p>
                      <p className="text-white">{getDayName(date)}</p>
                    </div>
                  </div> */}

                  {/* SLOTLIST COMPONENT (unchanged logic) */}
                  <SlotList
                    dateSlots={dateSlots}
                    doctorInfo={doctorInfo}
                    slotDate={date}
                    selectedDoctor={selectedDoctor}
                    selectedSpecialty={selectedSpecialty}
                    addNotification={addNotification}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorList;
